import React from 'react';

interface BuyMeACoffeeProps {
  variant?: 'button' | 'link';
  size?: 'small' | 'medium' | 'large';
  text?: string;
}

const BuyMeACoffee: React.FC<BuyMeACoffeeProps> = ({
  variant = 'button',
  size = 'medium',
  text = 'Buy Me a Coffee'
}) => {
  const username = 'stafidopsomo';
  const url = `https://buymeacoffee.com/${username}`;

  if (variant === 'link') {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="buy-me-a-coffee-link"
        style={{
          color: 'var(--electric-blue)',
          textDecoration: 'none',
          fontSize: size === 'small' ? '0.9rem' : '1rem',
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          transition: 'color 0.2s ease'
        }}
      >
        ☕ {text}
      </a>
    );
  }

  const sizeStyles = {
    small: {
      padding: '8px 16px',
      fontSize: '0.85rem',
      iconSize: '16px'
    },
    medium: {
      padding: '12px 24px',
      fontSize: '1rem',
      iconSize: '20px'
    },
    large: {
      padding: '16px 32px',
      fontSize: '1.1rem',
      iconSize: '24px'
    }
  };

  const style = sizeStyles[size];

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="buy-me-a-coffee-button"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        padding: style.padding,
        background: 'linear-gradient(135deg, #FFDD00 0%, #FDB813 100%)',
        color: '#000000',
        textDecoration: 'none',
        fontWeight: 700,
        fontSize: style.fontSize,
        border: '3px solid #000000',
        borderRadius: '12px',
        boxShadow: '4px 4px 0 rgba(0, 0, 0, 0.3)',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translate(-2px, -2px)';
        e.currentTarget.style.boxShadow = '6px 6px 0 rgba(0, 0, 0, 0.3)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translate(0, 0)';
        e.currentTarget.style.boxShadow = '4px 4px 0 rgba(0, 0, 0, 0.3)';
      }}
    >
      <span style={{ fontSize: style.iconSize }}>☕</span>
      <span>{text}</span>
    </a>
  );
};

export default BuyMeACoffee;
